import { render } from "./AdditionalSecurity.vue?vue&type=template&id=0197b885&scoped=true"
import script from "./AdditionalSecurity.vue?vue&type=script&lang=js"
export * from "./AdditionalSecurity.vue?vue&type=script&lang=js"

import "./AdditionalSecurity.vue?vue&type=style&index=0&id=0197b885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0197b885"]])

export default __exports__